var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarOutside(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-2",
    d: "M4 9H16C17.3789 9 18.5 10.1211 18.5 11.5V23C18.5 23.2739 18.2739 23.5 18 23.5H2C1.72614 23.5 1.5 23.2739 1.5 23V11.5C1.5 10.1211 2.62114 9 4 9Z",
    fill: "#EAEEF2",
    stroke: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M13.25 3.125H2.75C2.335 3.125 2 2.79 2 2.375C2 1.96 2.335 1.625 2.75 1.625H13.25C13.665 1.625 14 1.96 14 2.375C14 2.79 13.665 3.125 13.25 3.125Z",
    fill: "#AFB8C1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M17.25 6.375H2.75C2.335 6.375 2 6.04 2 5.625C2 5.21 2.335 4.875 2.75 4.875H17.25C17.665 4.875 18 5.21 18 5.625C18 6.04 17.665 6.375 17.25 6.375Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarOutside);
export default __webpack_public_path__ + "static/media/bar-outside.5e334708edc8a906ae3904b3eafbc44d.svg";
export { ForwardRef as ReactComponent };